import { useEffect, useState } from "react";
import { msalInstance, powerbiScopes } from "../services/authService";
import { InteractionRequiredAuthError } from "@azure/msal-browser";

// Solo para obtener token de Power BI (NO login app)
export const useAuth = () => {
  const [account, setAccount] = useState(null);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const initAuth = async () => {
    setLoading(true);
    try {
      await msalInstance.initialize();
      const redirectResponse = await msalInstance.handleRedirectPromise();
      if (redirectResponse) {
        msalInstance.setActiveAccount(redirectResponse.account);
        setAccount(redirectResponse.account);
        setToken(redirectResponse.accessToken);
        setError(null);
        setLoading(false);
        return;
      }
      let activeAccount = msalInstance.getActiveAccount();
      if (!activeAccount) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
          activeAccount = accounts[0];
          msalInstance.setActiveAccount(activeAccount);
        }
      }
      if (!activeAccount) {
        throw new Error("No hay sesión activa para Power BI");
      }
      // Solo token Power BI
      const silentResponse = await msalInstance.acquireTokenSilent({
        scopes: powerbiScopes,
        account: activeAccount,
      });
      setAccount(activeAccount);
      setToken(silentResponse.accessToken);
      setError(null);
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        setError(new Error('Sesión Power BI expirada. Inicia sesión nuevamente.'));
      } else {
        setError(err);
      }
      setAccount(null);
      setToken(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    initAuth();
  }, []);

  return { account, token, error, loading, refreshAuth: initAuth };
};